export default __webpack_public_path__ + "static/media/IMG_8088.84b3cfb0.webp";